export enum StatusLightBordersEnum {
  GRAY = 'status-light-gray-border',
  WHITE = 'status-light-white-border',
  NONE = 'status-light-none-border',
}
